// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expandwidth-enter-active[data-v-51804d6c]{transition:width .15s var(--trans-standart);overflow:hidden}.expandwidth-leave-active[data-v-51804d6c]{transition:width .1s var(--trans-decelerate);overflow:hidden}.expandwidth-enter[data-v-51804d6c],.expandwidth-leave-to[data-v-51804d6c]{width:0}", ""]);
// Exports
module.exports = exports;
